import { useState } from "react";
import * as AiIcons from "react-icons/ai";
import { Button, Alert, Modal, Table } from 'react-bootstrap';
import { Form, Container, Row } from 'react-bootstrap';
import { useDispatch, } from "react-redux";
import { useSelector } from 'react-redux';
import { FaListOl } from "react-icons/fa6";
import { usdCurrencyFormat } from "./numberFormats";


var newDate = new Date();
//var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()
var gtDate = new Date().toLocaleString() + ""; 

function QuoteVersionDetails(props) { 
  const [lgShow, setLgShow] = useState(false);

  const dispatch = useDispatch();

  // This is how you make the current user available on any functional component
  const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    setLgShow(true); 
    console.log(props.calcs);
  }
    return (
      <>
        <Button onClick={handleShow} className='ms-2' lg={8} style={{maxWidth:"50px",maxHeight:'38px'}} variant="primary"><FaListOl /></Button>          
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'View Quote Details'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
              <thead>
                <tr>
                  <th style={{width:'50%'}}>Concept</th>
                  <th style={{width:'50%'}}>Calculation</th>
                  <th style={{width:'50%',textAlign:'right'}}>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1 ASSEMBLY COST</td>
                  <td>
                    {"B+W = $" + 
                    props.assemblycostbasewallcost + 
                    "/cab || T = $" + 
                    props.assemblycosttallcost + 
                    "/cab"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.assemblycost_1)}</td>
                </tr>
                <tr>
                  <td>2 HINGES COST</td>
                  <td>
                    {"B+W = " + 
                    props.hardwarehingesbasewallcost + 
                    " hinges/cab || T = " + 
                    props.hardwarehingestallcost + 
                    " hinges/cab, " +
                    "$9/hinge"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.hingescost_2)}</td>
                </tr>                
                <tr>
                  <td>4 ROUTING COST CASE</td>
                  <td>
                    {"Routing cost = $" + props.routingcost + 
                    ", B=" + props.routingcostcasesqftbase + 
                    ", W=" + props.routingcostcasesqftwall +
                    ", T=" + props.routingcostcasesqfttall}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.routingcostcase_4)}</td>
                </tr>                                
                <tr>
                  <td>5 ROUTING COST BACKS</td>
                  <td>
                    {"Routing cost = $" + props.routingcost + 
                    ", B=" + props.routingcostbacksqftbase + 
                    ", W=" + props.routingcostbacksqftwall +
                    ", T=" + props.routingcostbacksqfttall}                    
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.routingcostback_5)}</td>
                </tr>                                
                <tr>
                  <td>6 ROUTING COST DOORS</td>
                  <td>
                    {"Routing cost = $" + props.routingcost + 
                    ", B=" + props.routingcostdoorssqftbase + 
                    ", W=" + props.routingcostdoorssqftwall +
                    ", T=" + props.routingcostdoorssqfttall}                    
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.routingcostdoors_6)}</td>
                </tr>                                
                <tr>
                  <td>7 ROUTING FINISH ENDS AND PANELS</td>
                  <td>
                    {"Routing cost = $" + props.routingcost + 
                    ", B=" + props.routingcostfinishendssqftbase + 
                    ", W=" + props.routingcostfinishendssqftwall +
                    ", T=" + props.routingcostfinishendssqfttall}     
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.routingfinishedends_7)}</td>
                </tr>                                                
                <tr>
                  <td>8 MATERIAL COST CASE</td>
                  <td>
                    {"Markup=" + 100*props.materialcostcasemarkup + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.materialcostcase_8)}</td>
                </tr>                                                  
                <tr>
                  <td>9 MATERIAL COST BACKS</td>
                  <td>
                    {"Markup=" + 100*props.materialcostbackmarkup + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.materialcostmaterialbacks_9)}</td>
                </tr>                                                           
                <tr>
                  <td>10 MATERIAL COST DOORS</td>
                  <td>
                    {"Markup=" + 100*props.materialcostdoorsmarkup + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.materialcostmaterialdoors_10)}</td>
                </tr>                                                            
                <tr>
                  <td>10 MATERIAL COST FINISH ENDS</td>
                  <td>
                    {"Markup=" + 100*props.materialcostfinishendsmarkup + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.materialcostfinishends_11)}</td>
                </tr>                                                         
                <tr>
                  <td>11 EB COST CASE</td>
                  <td>
                    {"B=" + props.ebcostcasebase + " lnft, " +
                    "W=" + props.ebcostcasewall + " lnft, " +
                    "T=" + props.ebcostcasetall + " lnft, " +
                    "Markup=" + 100*props.ebcostcasemarkup + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.ebcostbase_12)}</td>
                </tr>                                             
                <tr>
                  <td>12 EB COST DOORS</td>
                  <td>
                    {"B=" + props.ebcostdoorsbase + " lnft, " +
                    "W=" + props.ebcostdoorswall + " lnft, " +
                    "T=" + props.ebcostdoorstall + " lnft, " +
                    "Markup=" + 100*props.ebcostdoorsmarkup + "%"}                    
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.ebcostdoors_13)}</td>
                </tr>                                              
                <tr>
                  <td>14 DRAWER COST</td>
                  <td>
                    {"$" + props.drawercostdrawer + 
                    "/drawer + $" + props.drawercosthardware + " hardware, Markup=" + 100*props.drawercostmarkup + "%"}                                       
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totaldrawercost_15)}</td>
                </tr>   
                <tr>
                  <td>16 TOE KICKS, FILLERS...</td>
                  <td></td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totalyescosttoekicks_16)}</td>
                </tr>                                                       
                <tr>
                  <td>17 FACE FRAME</td>
                  <td>
                    {"Face frame markup=" + 100*props.faceframemarkup + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totalyesframe_17)}</td>
                </tr>                                                
                <tr>
                  <td>18 INSTALLATION</td>
                  <td>
                    {"Instalation/day=$" + props.calcs.totalyescostinstallation_18}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totalyescostinstallation_18)}</td>
                </tr>                                                           
                <tr>
                  <td>19 DELIVERY</td>
                  <td>
                    {"Basic Delivery Cost 40 cabinets ->$" + props.basicdeliverycost40cab}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totalyescostdelivery_19)}</td>
                </tr>                            
                <tr>
                  <td>TOTAL QUOTE</td>
                  <td></td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totalquoteversion)}</td>
                </tr>
                <tr>
                  <td>TOTAL COST + UNKNOWN FACTOR</td>
                  <td>
                    {"Unknown factor=" + 100*props.unknownfactor + "%"}
                  </td>
                  <td style={{textAlign:'right'}}>{usdCurrencyFormat(props.calcs.totalquoteversionwithunknownfactor)}</td>
                </tr>                                                                                                                                                                                                                                                                
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default QuoteVersionDetails;